module.exports = __webpack_public_path__ + "static/fwen-8754776edd590f1b1ddb2f51f8f542db.jpeg";